import { useState } from "react";
import { refusedBulletins } from "../../../api/social";
import { ModalProps } from "../../../interfaces/modal";
import { showToastError, showToastSuccess } from "../../../services/toast";
import { useSocialStore } from "../../../stores/social";
import { TextArea } from "../../ui/inputs/TextArea";
import { useTranslation } from "react-i18next";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "../../ui/modals/ModalShell";

const Refused: React.FC<ModalProps> = ({ closeModal }) => {
  const { t } = useTranslation();
  // Store
  const { idCustomer, updateSocial, setUpdateSocial } = useSocialStore();
  const [commentaire, setCommentaire] = useState("");

  const handleRefused = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    refusedBulletins(idCustomer, {commentary: commentaire})
      .then(() => {
        showToastSuccess(t("Les bulletins ont été refusés avec succès"));
        setCommentaire("");
        setUpdateSocial(!updateSocial);
        closeModal();
      })
      .catch(() => {
        showToastError(t("Erreur lors de la validation des bulletins"));
      });
  };

  return (
    <ModalShell
      title={t("Refuser les bulletins")}
      size="sm"
      onClose={closeModal}
      footer={
        <>
          <ModalButton variant="secondary" onClick={closeModal}>
            {t("Annuler")}
          </ModalButton>
          <ModalButton variant="danger" onClick={(e) => handleRefused(e)}>
            {t("Refuser")}
          </ModalButton>
        </>
      }
    >
      <ModalConfirmText>
        {t("Etes vous sur de bien vouloir refuser les bulletins séléctionnés ?")}
      </ModalConfirmText>
      <p className="mt-3 mb-4 rounded-xl bg-amber-50 px-3 py-2 text-center font-Nunito text-xs text-amber-800 ring-1 ring-amber-100 ring-inset">
        {t("Cette action est irréversible.")}
      </p>

      <TextArea
        label={t("Commentaire")}
        name="commentaire"
        value={commentaire}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setCommentaire(e.target.value)}
        clasName="w-full"
      />
    </ModalShell>
  );
};

export default Refused;
